/** Ordinary bars/trading require calendar and execution admission before accepting a product. */
export function requireOrdinaryEntityType(entityType) {
    if (entityType === 'Asset' || entityType === 'AssetIndex' || entityType === 'Cryptocurrency')
        return entityType;
    throw new Error(`Ordinary market-data/trading routes do not yet support ${entityType}`);
}
//# sourceMappingURL=entityAdmission.js.map